<template>
  <div class="row mx-0" id="admin-dashboards-goals">
    <div class="col-12 mt-3">
      <span class="h4">Informações de Serviços Docker</span>
      <span class="pl-2">{{ loadingSystemInfo ? 'Carregando...' : '' }}</span>
    </div>

    <div class="col-12 col-md-12 p-0">
      <div class="row p-0">
        <div class="col-12">
          <div class="row m-4 ">
            <div class="col-6 pr-4" v-for="value, key in filteredSystemInfo">
              <div class="card card-flat">
                <div class="card-header px-4 py-2 m-0 h2">
                  {{ key }}
                </div>
                <div class="card-body p-4">
                  <p class="h4 font-weight-bold m-0">Versão da Imagem: {{ value.image_tag }}</p>
                  <p class="h4 font-weight-bold m-0">Última Atualização: {{ value.update_date | formatDate("full") }}</p>
                </div>
                <div class="card-footer px-4 py-2">
                  <div class="row">
                    <div class="col-10">
                      <multiselect
                        placeholder="Selecione a Tag da Imagem"
                        v-model="asd"
                        :options="availableTags[key] || []"
                      />
                    </div>
                    <div class="col-2">
                      <base-button
                        type="primary"
                        @click="() => {}"
                      >
                        Atualizar
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onUnmounted, computed, watch } from 'vue';
import { basicAuthAxios } from '@/backend/axios';
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

const asd  = ref("")
const UPDATE_INTERVAL = 30000;
const systemInfo = ref({});
const loadingSystemInfo = ref(false);
const puller = ref()

onBeforeMount(() => {
  getSystemInfo()
  puller.value = setInterval(getSystemInfo, UPDATE_INTERVAL);
});

onUnmounted(() => {
  clearInterval(puller.value);
});

const systemInfoKeys = computed(() => {
  return {
    "Frontend": process.env.VUE_APP_FRONTEND_SERVICE,
    "Backend": process.env.VUE_APP_BACKEND_SERVICE,
    "Erp": process.env.VUE_APP_ERP_SERVICE,
    "Sidekiq": process.env.VUE_APP_SIDEKIQ_SERVICE,
  }
})

const getSystemInfo = async () => {
  loadingSystemInfo.value = true;

  try {
    const response = await basicAuthAxios.get("/webhook/system_info")
    systemInfo.value = response.data || {};
  } catch (e) {
    console.error(e);
  }

  loadingSystemInfo.value = false;
};

// const filteredSystemInfo = ref({
//   "sgv_backend": {
// 		"image_tag": "CU-86a4r1vem",
// 		"update_date": "2024-09-14T03:00:12Z"
// 	},
// })

const filteredSystemInfo = computed(() => {
  return Object.fromEntries(
    Object.entries(systemInfoKeys.value).map(([name, serviceName]) => [
      name, systemInfo.value[serviceName]
    ])
  );
});

const getAvailableTags = async (imageName) => {
  try {
    const response = await basicAuthAxios.get(`/webhook/avaliable_tags?image_name=${imageName}`)
    return response.data
  } catch(error) {
    console.error(e);
  }
}

const availableTags = ref({})

watch(filteredSystemInfo, (value) => {
  value.forEach(async (service) => $set(availableTags.value, 'value.name', await getAvailableTags(service.image_name)))
})

</script>